"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ReviewRequest {
    constructor(referenceNumber) {
        this.referenceNumber = referenceNumber;
    }
}
exports.default = ReviewRequest;
//# sourceMappingURL=ReviewRequest.js.map